import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { Spin } from 'antd'
import { useAuth } from '../hooks/useAuth'

interface PrivateRouteProps {
  requiredRole?: 'admin' | 'super_admin'
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ requiredRole }) => {
  const { isAuthenticated, isAdmin, isLoading, user } = useAuth()

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <Spin size="large" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // 检查角色权限
  if (requiredRole) {
    if (requiredRole === 'super_admin' && user?.role !== 'super_admin') {
      return <Navigate to="/dashboard" replace />
    }
    if (requiredRole === 'admin' && !isAdmin) {
      return <Navigate to="/dashboard" replace />
    }
  }

  return <Outlet />
}

export default PrivateRoute
